import { defineMessages } from 'utils/intl';

export default defineMessages({
  rugged:
    'Niezależnie od tego, czy dopiero zaczynasz budować swój van, czy jesteś doświadczonym budowniczym z wieloma vanami przygodowymi na koncie, jesteśmy tutaj, aby Ci pomóc!',
  // redarc:
  //   'Zaprojektowane, przetestowane i wyprodukowane w Australii produkty REDARC są stworzone, aby sprostać najtrudniejszym warunkom na świeżym powietrzu.\n\nNiezależnie od tego, gdzie na świecie zaprowadzą Cię Twoje przygody, podróżuj pewnie z REDARC Electronics.',
});
